import { render, staticRenderFns } from "./dispatchList.vue?vue&type=template&id=5dbfb57f&scoped=true&"
import script from "./dispatchList.vue?vue&type=script&lang=js&"
export * from "./dispatchList.vue?vue&type=script&lang=js&"
import style0 from "./dispatchList.vue?vue&type=style&index=0&id=5dbfb57f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbfb57f",
  null
  
)

export default component.exports